import { LEVELS } from "@package/map";
import { Card, Stack, Typography, Switch } from "@mui/material";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility } from "Redux/supportInventorySlice";
import { changeShowSupportLeftSide, changeSupportRightSideMode } from "Redux/supportSideSlice";

export default function Inventory() {
  const dispatch = useAppDispatch();

  const { visible } = useAppSelector((state) => state.supportInventory);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleVisible = () => {
    dispatch(changeSupportRightSideMode(1));
    dispatch(toggleVisibility());
    dispatch(changeShowSupportLeftSide(false));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleVisible} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
